import { OpenInNew, ShoppingCart } from '@mui/icons-material';
import { Button, IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Fragment } from 'react';

import { formatCommunityProductPrice } from '@jebel/utils';

import { CommunityProductFragment, CommunitySubscriptionFragment } from 'shared/graphql';
import { useMediaDetailer, useMediaPreview, useModalState, useResponsive } from 'shared/hooks';

import { CommunityProductPurchaseDetailsModal } from '../CommunityProductPurchaseDetailsModal';
import { ProductLogo } from './CommunityProductPurchaseListItem.styles';

interface Props {
  product: CommunityProductFragment | CommunitySubscriptionFragment;
}

export function CommunityProductPurchaseListItem({ product }: Props) {
  const {
    show: showProductModal,
    open: openProductModal,
    close: closeProductModal,
  } = useModalState();

  const { isMobile } = useResponsive();
  const { data: image } = useMediaDetailer(product.image);
  const { src: logoSrc, srcSet: logoSrcSet } = useMediaPreview(product.image);

  const secondaryText = formatCommunityProductPrice(product);

  return (
    <Fragment>
      <ListItem
        onClick={openProductModal}
        secondaryAction={
          isMobile ? (
            <IconButton>
              <OpenInNew fontSize="small" />
            </IconButton>
          ) : (
            <Button startIcon={<OpenInNew fontSize="small" />}>View Details</Button>
          )
        }
      >
        <ListItemIcon>
          <ProductLogo
            src={logoSrc}
            srcSet={logoSrcSet}
            color={product.membership?.color}
            alt={image?.filename ?? product.name}
          >
            <ShoppingCart fontSize="inherit" />
          </ProductLogo>
        </ListItemIcon>

        <ListItemText primary={product.name} secondary={secondaryText} />
      </ListItem>

      <CommunityProductPurchaseDetailsModal
        open={showProductModal}
        product={product}
        onClose={closeProductModal}
      />
    </Fragment>
  );
}
